import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveJudgesAction, updateJudgesAction } from '../../../actions/judgesActions';
import { listAudienceTypesAction } from '../../../actions/audienceTypesActions';
import { listOfijusAction } from '../../../actions/ofijusActions';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import binaryData from '../../../data/binaryData';
import ButtonSpinner from '../../layout/ButtonSpinner';
//Función principal
const JudgeForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refApellido = useRef();
    //Datos iniciales
    const initialData = {
        apellido: '',
        nombre: '',
        legajo: '',
        email: '',
        telefono: '',
        menor: 0,
        ejecucion: 0,
        ofiju: '',
        tipos: []
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const judgesLoading = useSelector( state => state.judges.loadingSave );
    const errorSave = useSelector( state => state.judges.errorSave );
    const isEdit = useSelector( state => state.judges.isEdit );
    const judgeSelected = useSelector( state => state.judges.judgeSelected );
    const audienceTypes = useSelector( state => state.audienceTypes.audienceTypes );
    const ofijus = useSelector( state => state.ofijus.ofijus );
    //Inicializo el state local
    const [ judge, setJudge ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && judgeSelected){
            setJudge({
                ...judgeSelected,
                ofiju: judgeSelected.ofiju ? judgeSelected.ofiju.id : '',
                tipos: judgeSelected.audienciaTipoList && judgeSelected.audienciaTipoList.length > 0 ? (
                    judgeSelected.audienciaTipoList.map(type => type.id)
                ) : []
            });
        }else{
            setJudge(initialData);
        }
    }, [isEdit, judgeSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setJudge({
            ...judge,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            apellido: values.apellido,
            nombre: values.nombre,
            email: values.email,
            legajo: values.legajo,
            telefono: values.telefono,
            menor: values.menor,
            ejecucion: values.ejecucion,
            ofiju: {
                id: values.ofiju
            },
            activo: 1
        }

        let tiposData = [];

        values.tipos.map(tipo => {
            tiposData = [
                ...tiposData,
                {
                    id: tipo
                }
            ]
        });
        //Agrego los tipos a los datos
        data = {
            ...data,
            audienciaTipoList: tiposData
        }
        //return false;
        //Verifico si es edición o alta
        if(judge.id){
            //Agrego el ID a la data
            data = {
                id: judge.id,
                ...data
            }
            //Es edición
            dispatch( updateJudgesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveJudgesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si se cargaron los tipos
        if(!audienceTypes){
            dispatch( listAudienceTypesAction({
                search: 'activo:1'
            }) );
        }
        //Me fijo si se cargaron las ofijus
        if(!ofijus){
            dispatch( listOfijusAction({
                search: 'activo:1'
            }) );
        }
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setJudge(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        legajo: yup.number().required(),
        email: yup.string().email().required(),
        telefono: yup.string().nullable(),
        menor: yup.number().required(),
        ejecucion: yup.number().required(),
        tipos: yup.array().nullable(),
        ofiju: yup.number().required()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
            >
            <Modal.Header closeButton>
                <Modal.Title>
                    Juez&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...judge }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-6">
                                    <label htmlFor="apellido">Apellido</label>
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        ref={refApellido}
                                        isInvalid={!!errors.apellido}
                                        disabled={ judgesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="nombre">Nombre</label>
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ judgesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <label htmlFor="legajo">Legajo</label>
                                    <Form.Control
                                        id="legajo"
                                        className="form-control" 
                                        name="legajo" 
                                        type="text" 
                                        value={ values.legajo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.legajo}
                                        disabled={ judgesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.legajo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ judgesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="telefono">Teléfono</label>
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ judgesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="menor">Juez de Menores</label>
                                    <Form.Control
                                        as="select"
                                        id="menor"
                                        className="form-control"  
                                        name="menor" 
                                        value={ values.menor }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menor}
                                        disabled={ judgesLoading }
                                    >
                                        {
                                            binaryData.map(bd => (
                                                <option value={bd.id} key={`jm${bd.id}`}>
                                                    { bd.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menor }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-3">
                                    <label htmlFor="ejecucion">Juez de Ejecución</label>
                                    <Form.Control
                                        as="select"
                                        id="ejecucion"
                                        className="form-control"  
                                        name="ejecucion" 
                                        value={ values.ejecucion }
                                        onChange={handleChange}
                                        isInvalid={!!errors.ejecucion}
                                        disabled={ judgesLoading }
                                    >
                                        {
                                            binaryData.map(bd => (
                                                <option value={bd.id} key={`je${bd.id}`}>
                                                    { bd.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ejecucion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="ofiju">Ofiju</label>
                                    <Form.Control
                                        as="select"
                                        id="ofiju"
                                        className="form-control"  
                                        name="ofiju"  
                                        value={ values.ofiju }
                                        onChange={handleChange}
                                        isInvalid={!!errors.ofiju}
                                        disabled={ judgesLoading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {
                                            ofijus ? (
                                                ofijus.map(ofiju => (
                                                    <option value={ofiju.id} key={`jo${ofiju.id}`}>
                                                        { ofiju.nombre }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ofiju }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                { /* }
                                <Form.Group className="col-md-12">
                                    <label htmlFor="tipos">Tipo/s de Audiencia</label>
                                    <Form.Control
                                        as="select"
                                        multiple
                                        id="tipos"
                                        className="form-control"  
                                        name="tipos"  
                                        value={ values.tipos }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipos}
                                        disabled={ judgesLoading }
                                    >
                                        {
                                            audienceTypes ? (
                                                audienceTypes.map(audienceType => (
                                                    <option value={audienceType.id} key={`jat${audienceType.id}`}>
                                                        { audienceType.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipos }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                { */ }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                judgesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ judgesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ judgesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default JudgeForm;